import React from 'react';

function WonAuctionBadge(props) {
  if (!props.showBadge) {
    return null;
  }
  return (
    <span role="img" aria-label="prize" className='ml-2'>🏆</span>
  );
}

export default WonAuctionBadge;
